module.exports = __webpack_public_path__ + "img/notify2.fcbf7835.png";